var
    symbols = require('../utils/symbols'),
    PathFinder = require('./PathFinder'),
    Move = require('../core/Move'),
    Piece = symbols.Piece,
    Color = symbols.Color,
    DraughtsTypes = symbols.DraughtsTypes8x8
;

function Arbiter() {
}

Arbiter.pf = new PathFinder();

/** Crée le mouvement demandé. */
Arbiter.getMove = function(board, startingSqNum, endingSqNum, middleSquaresNum, previousColorPlayed) {
    const conf = board.conf;
    const draughtsType = board.getDraughtsType();
    // Toutes les combinaisons de rafles
    let listRafleMovements = Arbiter.pf.getRafleMovements(board, startingSqNum);
    let existsRafle = listRafleMovements.length > 0;

    let listMovements = [];

    // Ne conserver que la/les rafles majoritaires
    if (existsRafle) {
        // console.log("CAS : RAFLE");
        switch (draughtsType) {
            case DraughtsTypes.BRAZILIAN:
                listMovements = this._filterMajorityBrasilian(listRafleMovements);
            break;
            case DraughtsTypes.RUSSIAN:
                listMovements = this._filterDuplicates(listRafleMovements);
            break;
            case DraughtsTypes.CHECKERS:
                listMovements = this._filterDuplicates(listRafleMovements);
            break;
            case DraughtsTypes.ITALIAN:
                listMovements = this._filterDuplicates(listRafleMovements);
            break;
            default:
                listMovements = this._filterMajorityBrasilian(listRafleMovements);
            break;
        }
    }
    // Aucune prise possible => on regarde les déplacements simples
    else {
        // console.log("CAS : DEPLACEMENT SIMPLE");
        listMovements = Arbiter.pf.getSimpleMovements(board, startingSqNum);
    }


    // Ne conserver que le/les mouvements qui arrivent sur la case indiquée.
    let listOK = this._filterEnding(listMovements, endingSqNum);

    // Ne conserver que le/les mouvements qui passent par les cases
    // indiquées.
    if (middleSquaresNum != null && middleSquaresNum.length > 0) {
        listOK = this._filterInter(listOK, middleSquaresNum);
    }

    // Si plusieurs mouvements sont valides, on prendra le premier.
    let move = null;
    if (listOK.length > 0) {
        move = listOK[0];

        // Enregistrer les mouvements intermédiaires précisées
        if (middleSquaresNum != null) {
            move.middleSquaresNum = middleSquaresNum;
        }

        if (listOK.length > 1) {
            console.log("Il existe des variantes pour le coup " + startingSqNum + "/" + endingSqNum);
        }
    }

    // Le mouvement demandé est irrégulier.
    if (move == null) {
        move = new Move(startingSqNum, endingSqNum);
        move.status = false;
        move.message = "Mouvement irrégulier..."; // A préciser
    }

    // Préciser s'il s'agit d'une rafle (pour la notation)
    move.isCaptured = existsRafle;

    // Préciser si la piece a été promu en dame.
    let piece = board.getPiece(startingSqNum);
    let isCrowned = false;
    
    switch (draughtsType) {
        case DraughtsTypes.BRAZILIAN:
            isCrowned = (piece === Piece.PAWN_WHITE && endingSqNum >= conf['W_CROWNED'][0] && endingSqNum <= conf['W_CROWNED'][1]);
            isCrowned = isCrowned || (piece === Piece.PAWN_BLACK && endingSqNum >= conf['B_CROWNED'][0] && endingSqNum <= conf['B_CROWNED'][1]);
        break;
        case DraughtsTypes.RUSSIAN:
            if (piece === Piece.PAWN_WHITE) {
                isCrowned = board.checkIsPromoteInWay(piece, [...move.landingSquaresNum, endingSqNum]);
            }
            if (piece === Piece.PAWN_BLACK && !isCrowned) {
                isCrowned = board.checkIsPromoteInWay(piece, [...move.landingSquaresNum, endingSqNum]);
            }
        break;
        default:
            isCrowned = (piece === Piece.PAWN_WHITE && endingSqNum >= conf['W_CROWNED'][0] && endingSqNum <= conf['W_CROWNED'][1]);
            isCrowned = isCrowned || (piece === Piece.PAWN_BLACK && endingSqNum >= conf['B_CROWNED'][0] && endingSqNum <= conf['B_CROWNED'][1]);
        break;
    }
    move.isCrowned = isCrowned;

    // Colour which plays this movement.
    move.color = board.getColor(startingSqNum);

    switch (draughtsType) {
        case DraughtsTypes.BRAZILIAN:
        break;
        case DraughtsTypes.RUSSIAN:
      
        break;
        default:
        break;
    }

    // Check white play after black and vice versa.
    if (previousColorPlayed){
        if (move.color === previousColorPlayed){
            move.status = false;
            move.message = "Ce joueur a déjà joué le coup précédent...";
        }
    }

    return move;
};

 
Arbiter._filterMajorityBrasilian = function(moves) {
    let list = [];

    let lMax = this._moveMax(moves);
    for (let k = 0; k < moves.length; k++) {
        let m = moves[k];
        if (m.size() === lMax) {
            list.push(m);
        }
    }

    list = this._filterDuplicates(list);

    return list;
};

Arbiter._filterDuplicates = function(moves) {
    let list = []; // [Move]

    if (moves.length > 1) {
        for (let k = 0; k < moves.length; k++) {
            let m = moves[k];
            let isDuplicate = false;
            for (let j = 0; j < list.length; j++) {
                let cf = list[j];
                if (m === cf) {
                    isDuplicate = true;
                }
            }
            if (!isDuplicate) {
                list.push(m);
            }
        }
    } else {
        list = moves;
    }

    return list;
};

/** Longueur du plus long mouvement. */
Arbiter._moveMax = function(moves) {
    let lMax = -1;

    for (let k = 0; k < moves.length; k++) {
        let m = moves[k];
        if (m.size() > lMax) {
            lMax = m.size();
        }
    }
    return lMax;
};

/** Ne conserve que les mouvements qui arrivent sur la case indiquée. */
Arbiter._filterEnding = function(moves, endNum) {
    let list = []; // [Move]

    for (let k = 0; k < moves.length; k++) {
        let m = moves[k];
        if (m.endingSquareNum === endNum) {
            list.push(m);
        }
    }
    return list;
};

/**
 * Ne conserve que les mouvements qui passent par les cases intermédiaires
 * indiquées.
 * 
 * @param inters
 *            : REQUIS, non null
 */
Arbiter._filterInter = function(moves, middleSquaresNum) {
    let list = []; // [Move]

    if (moves != null) {
        // Pour chaque mouvement
        for (let k = 0; k < moves.length; k++) {
            let m = moves[k];

            let landingSquaresNum = m.landingSquaresNum;
            let allFound = true;
            let nbLanding = landingSquaresNum.length;

            let lastIdxPose = -1;

            // Pour chaque inter spécifié
            for (let j = 0; j < middleSquaresNum.length; j++) {
                let inter = middleSquaresNum[j];

                // On regarde s'il fait partie des cases sur laquelle la pièce s'est posée
                let found = false;
                for (let idxPose = 0; idxPose < nbLanding; idxPose++) {
                    // La case posée existe
                    if (inter === landingSquaresNum[idxPose]) {
                        // ET on ne l'a pas déjà prise en compte
                        if (idxPose > lastIdxPose) {
                            found = true;
                            lastIdxPose = idxPose;
                        }
                    }
                }

                if (!found) {
                    allFound = false;
                    break; // mouvement suivant
                }
            }

            if (allFound) {
                list.push(m);
            }

        }
    }
    return list;
};

module.exports = Arbiter;



// WEBPACK FOOTER //
// ./src/board/brain/Arbiter.js